import { isMobileUserAgent } from './isMobileUserAgent';
export var isMobileDevice = function isMobileDevice() {
  return (// tslint:disable-next-line: strict-type-predicates
    typeof navigator !== 'undefined' && isMobileUserAgent(navigator.userAgent)
  );
};